/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module CportalModule */

import { Component } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';

import './smart-operations-widget.component.less';
import { CPortalPageStore } from '../cportal-page.store';
import * as l10n from './smart-operations-widget.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 * Widget to display Smart Operations within the cloud service page.
 * @author Deepak Chaudhary
 */
@Component({
    selector: 'smart-operations-widget',
    templateUrl: './smart-operations-widget.component.html',
})
export class SmartOperationsWidgetComponent {
    public readonly pulseCloudServiceOrgDashboardsVisibility$ = this.cPortalPageStore
        .pulseCloudServiceOrgDashboardsVisibility$;

    public readonly l10nKeys = l10nKeys;

    constructor(
        l10nService: L10nService,
        private readonly cPortalPageStore: CPortalPageStore,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }
}
